import { createFileRoute } from '@tanstack/react-router'

import { SpekoNumbersPage } from '#/modules/communication/speko-numbers-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/speko-numbers')({
  component: SpekoNumbersPage,
  validateSearch: validateListSearch,
})
